module.exports = __webpack_public_path__ + "img/monarch-ui-icon_PATHWAYS.123cb200.png";